"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var DetailDataSingleLabel_1 = __importDefault(require("../contract_form/DetailDataSingleLabel"));
var SalesForceButtonArea_1 = __importDefault(require("./SalesForceButtonArea"));
var ReflectType_1 = require("../../../common/src/types/sales_force/ReflectType");
var MoveSalesForceButton_1 = __importDefault(require("./MoveSalesForceButton"));
var value_checker_1 = __importDefault(require("../../../common/src/utils/validation/value_checker"));
var SimpleDialog_1 = __importDefault(require("../globals/SimpleDialog"));
var invite_1 = __importDefault(require("../../utils/mail/template/invite"));
var scheduled_application_1 = __importDefault(require("../../utils/sales_force/template/scheduled_application"));
var price_book_utils_1 = __importDefault(require("../../../common/src/utils/sales_force/price_book_utils"));
var sales_force_input_utils_1 = __importDefault(require("../../../common/src/constrains/sales_force_input/sales_force_input_utils"));
var dayjs_1 = __importDefault(require("dayjs"));
var ApplicationDetailsPre = /** @class */ (function (_super) {
    __extends(ApplicationDetailsPre, _super);
    function ApplicationDetailsPre() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.form = {};
        _this.showAlertDialog = false;
        _this.alertMessage = '';
        _this.showConfirmDialog = false;
        _this.confirmMessage = '';
        _this.salesForceInfo = {
            torihikisakiId: '',
            kobetuPriceBook2Id: '',
            applyTorihikisakiId: '',
            applicationDetailId: '',
            emailSubjectPre: '',
            emailContentPre: '',
            emailAutoSendPre: '',
            scheduledApplicationContent: '',
            useKobetuFreePeriod: [],
            oralCarePriceBook2Id: '',
            useOralCareFreePeriod: [],
            toUpgradePriceBook2Id: '',
            basicPriceBook2Id: '',
            entryPriceBook2Id: '',
            mediumPriceBook2Id: '',
            standardPriceBook2Id: '',
            professionalPriceBook2Id: '',
            additionalTabletPriceBook2Id: '',
            motionAiPriceBook2Id: '',
            oldStandardPriceBook2Id: '',
            toUpgradeStartDate: '',
            applyInfoEntryStartDate: '',
            applyInfoBasicStartDate: '',
            applyInfoOldStandardStartDate: '',
            applyInfoMediumStartDate: '',
            applyInfoStandardStartDate: '',
            applyInfoProfessionalStartDate: '',
            entryPrimaryAssignedIdFlg: '',
            basicPrimaryAssignedIdFlg: '',
            oldStandardPrimaryAssignedIdFlg: '',
            mediumPrimaryAssignedIdFlg: '',
            standardPrimaryAssignedIdFlg: '',
            professionalPrimaryAssignedIdFlg: '',
            upgradePrimaryAssignedIdFlg: '',
            corporateEkycSkipFlg: '',
            personalEkycSkipFlg: '',
            isSequentialContractState: ''
        };
        _this.inviteMailSentenceType = new Array();
        _this.conmpareContractDateArray = new Array();
        _this.conmpareContractResultArray = new Array();
        return _this;
    }
    ApplicationDetailsPre.prototype.refs = function () {
        return this.$refs;
    };
    ApplicationDetailsPre.prototype.mounted = function () {
        this.initDataChange();
        this.initSalesForceDataChange();
    };
    ApplicationDetailsPre.prototype.initDataChange = function () {
        this.form = this.initData;
    };
    ApplicationDetailsPre.prototype.initSalesForceDataChange = function () {
        this.salesForceInfo = this.initSalesForceData;
        this.salesForceInfo.emailAutoSendPre = 'true';
        // 申込内容の連続性チェックを行う配列の初期化
        this.conmpareContractDateArray = [];
        this.conmpareContractResultArray = [];
        var upgradeToStandardFlg = value_checker_1.default.isPresent(this.salesForceInfo.validUpgradeToStandardFlg) ?
            JSON.parse(this.salesForceInfo.validUpgradeToStandardFlg.toLowerCase()) :
            false;
        if (value_checker_1.default.isPresent(this.salesForceInfo.kobetuPriceBook2Id) && price_book_utils_1.default.isAbnormal(this.salesForceInfo.kobetuPriceBook2Id, this.salesForceInfo.useKobetuFreePeriod)) {
            this.salesForceInfo.emailAutoSendPre = '';
        }
        if (value_checker_1.default.isPresent(this.salesForceInfo.oralCarePriceBook2Id) && price_book_utils_1.default.isAbnormal(this.salesForceInfo.oralCarePriceBook2Id, this.salesForceInfo.useOralCareFreePeriod)) {
            this.salesForceInfo.emailAutoSendPre = '';
        }
        if (value_checker_1.default.isPresent(this.salesForceInfo.entryPriceBook2Id) && price_book_utils_1.default.isAbnormal(this.salesForceInfo.entryPriceBook2Id, false)) {
            this.salesForceInfo.emailAutoSendPre = '';
            if (!this.inviteMailSentenceType.includes('entry')) {
                this.inviteMailSentenceType.push('entry');
            }
            if (value_checker_1.default.isPresent(this.salesForceInfo.applyInfoEntryStartDate)) {
                this.conmpareContractDateArray.push({ startDate: this.salesForceInfo.applyInfoEntryStartDate, planName: "entry" });
            }
        }
        if (value_checker_1.default.isPresent(this.salesForceInfo.toUpgradePriceBook2Id) && price_book_utils_1.default.isAbnormal(this.salesForceInfo.toUpgradePriceBook2Id, false)) {
            this.salesForceInfo.emailAutoSendPre = '';
            if (!this.inviteMailSentenceType.includes('toUpgrade')) {
                this.inviteMailSentenceType.push('toUpgrade');
            }
        }
        if (value_checker_1.default.isPresent(this.salesForceInfo.basicPriceBook2Id) && price_book_utils_1.default.isAbnormal(this.salesForceInfo.basicPriceBook2Id, false)) {
            this.salesForceInfo.emailAutoSendPre = '';
            if (!this.inviteMailSentenceType.includes('basic')) {
                this.inviteMailSentenceType.push('basic');
            }
            if (value_checker_1.default.isPresent(this.salesForceInfo.applyInfoBasicStartDate)) {
                this.conmpareContractDateArray.push({ startDate: this.salesForceInfo.applyInfoBasicStartDate, planName: "basic" });
            }
        }
        if (value_checker_1.default.isPresent(this.salesForceInfo.oldStandardPriceBook2Id) && price_book_utils_1.default.isAbnormal(this.salesForceInfo.oldStandardPriceBook2Id, false)) {
            this.salesForceInfo.emailAutoSendPre = '';
            if (!this.inviteMailSentenceType.includes('oldStandard')) {
                this.inviteMailSentenceType.push('oldStandard');
            }
        }
        if (value_checker_1.default.isPresent(this.salesForceInfo.mediumPriceBook2Id) && price_book_utils_1.default.isAbnormal(this.salesForceInfo.mediumPriceBook2Id, false)) {
            this.salesForceInfo.emailAutoSendPre = '';
            if (!this.inviteMailSentenceType.includes('medium')) {
                this.inviteMailSentenceType.push('medium');
            }
            if (value_checker_1.default.isPresent(this.salesForceInfo.applyInfoMediumStartDate)) {
                this.conmpareContractDateArray.push({ startDate: this.salesForceInfo.applyInfoMediumStartDate, planName: "medium" });
            }
        }
        if (value_checker_1.default.isPresent(this.salesForceInfo.standardPriceBook2Id) && price_book_utils_1.default.isAbnormal(this.salesForceInfo.standardPriceBook2Id, false)) {
            this.salesForceInfo.emailAutoSendPre = '';
            if (!this.inviteMailSentenceType.includes('standard')) {
                this.inviteMailSentenceType.push('standard');
            }
            if (value_checker_1.default.isPresent(this.salesForceInfo.applyInfoStandardStartDate)) {
                this.conmpareContractDateArray.push({ startDate: this.salesForceInfo.applyInfoStandardStartDate, planName: "standard" });
            }
        }
        if (value_checker_1.default.isPresent(this.salesForceInfo.professionalPriceBook2Id) && price_book_utils_1.default.isAbnormal(this.salesForceInfo.professionalPriceBook2Id, false)) {
            this.salesForceInfo.emailAutoSendPre = '';
            if (!this.inviteMailSentenceType.includes('professional')) {
                this.inviteMailSentenceType.push('professional');
            }
            if (value_checker_1.default.isPresent(this.salesForceInfo.applyInfoProfessionalStartDate)) {
                this.conmpareContractDateArray.push({ startDate: this.salesForceInfo.applyInfoProfessionalStartDate, planName: "professional" });
            }
        }
        if (upgradeToStandardFlg) {
            this.salesForceInfo.emailAutoSendPre = '';
            if (!this.inviteMailSentenceType.includes('upgrade')) {
                this.inviteMailSentenceType.push('upgrade');
            }
        }
        if (value_checker_1.default.isPresent(this.salesForceInfo.additionalTabletPriceBook2Id) && price_book_utils_1.default.isAbnormal(this.salesForceInfo.additionalTabletPriceBook2Id, false)) {
            this.salesForceInfo.emailAutoSendPre = '';
            // タブレット単体申込みが存在していた場合、必ずekycを実施する。
            this.salesForceInfo.personalEkycSkipFlg = '';
            this.salesForceInfo.corporateEkycSkipFlg = '';
            if (!this.inviteMailSentenceType.includes('tablet')) {
                this.inviteMailSentenceType.push('tablet');
            }
        }
        if (value_checker_1.default.isPresent(this.salesForceInfo.motionAiPriceBook2Id) && price_book_utils_1.default.isAbnormal(this.salesForceInfo.motionAiPriceBook2Id, false)) {
            this.salesForceInfo.emailAutoSendPre = '';
            if (!this.inviteMailSentenceType.includes('motionAi')) {
                this.inviteMailSentenceType.push('motionAi');
            }
        }
        this.salesForceInfo.emailContentPre = invite_1.default.getContents(this.documentId, this.form.officeInfoOfficeName, this.inviteMailSentenceType, this.salesForceInfo.personalEkycSkipFlg);
        this.salesForceInfo.scheduledApplicationContent = scheduled_application_1.default.getContents(this.salesForceInfo);
        this.salesForceInfo.emailSubjectPre = this.$t('view.sales_force.reflect.data_labels.application_details.email_subject_pre', { office_name: this.form.officeInfoOfficeName });
    };
    ApplicationDetailsPre.prototype.getEarliestDateVariable = function (entryStartDate, basicStartDate, oldStandardStartDate, mediumStartDate, standardStartDate, professionalStartDate, toUpgradeStartDate) {
        var compareArray = [];
        var earliestPropertyName = "";
        if (value_checker_1.default.isPresent(entryStartDate)) {
            compareArray.push({ entry: "'" + entryStartDate + "'" });
        }
        if (value_checker_1.default.isPresent(basicStartDate)) {
            compareArray.push({ basic: "'" + basicStartDate + "'" });
        }
        if (value_checker_1.default.isPresent(oldStandardStartDate)) {
            compareArray.push({ oldStandard: "'" + oldStandardStartDate + "'" });
        }
        if (value_checker_1.default.isPresent(mediumStartDate)) {
            compareArray.push({ medium: "'" + mediumStartDate + "'" });
        }
        if (value_checker_1.default.isPresent(standardStartDate)) {
            compareArray.push({ standard: "'" + standardStartDate + "'" });
        }
        if (value_checker_1.default.isPresent(professionalStartDate)) {
            compareArray.push({ professional: "'" + professionalStartDate + "'" });
        }
        if (value_checker_1.default.isPresent(toUpgradeStartDate)) {
            compareArray.push({ toUpgrade: "'" + toUpgradeStartDate + "'" });
        }
        var earliestProperty = function (objects) {
            var earliestDate = null;
            var earliestPropertyName = null;
            objects.forEach(function (obj) {
                for (var propName in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, propName)) {
                        var currentDate = dayjs_1.default(obj[propName]);
                        if (!earliestDate || currentDate.isBefore(earliestDate)) {
                            earliestDate = currentDate;
                            earliestPropertyName = propName;
                        }
                    }
                }
            });
            return earliestPropertyName;
        };
        earliestPropertyName = earliestProperty(compareArray);
        switch (earliestPropertyName) {
            case 'entry':
                this.salesForceInfo.entryPrimaryAssignedIdFlg = 'true';
                break;
            case 'basic':
                this.salesForceInfo.basicPrimaryAssignedIdFlg = 'true';
                break;
            case 'oldStandard':
                this.salesForceInfo.oldStandardPrimaryAssignedIdFlg = 'true';
                break;
            case 'medium':
                this.salesForceInfo.mediumPrimaryAssignedIdFlg = 'true';
                break;
            case 'standard':
                this.salesForceInfo.standardPrimaryAssignedIdFlg = 'true';
                break;
            case 'professional':
                this.salesForceInfo.professionalPrimaryAssignedIdFlg = 'true';
                break;
            case 'toUpgrade':
                this.salesForceInfo.upgradePrimaryAssignedIdFlg = 'true';
                break;
        }
    };
    ApplicationDetailsPre.prototype.checkContractStatusContinuityCheckRecord = function () {
        var self_ = this;
        // Message初期化
        self_.confirmMessage = '';
        if (self_.conmpareContractDateArray.length > 0 && self_.contractStatusContinuityCheckRecord.length > 0) {
            self_.conmpareContractResultArray = self_.contractStatusContinuityCheckRecord.map(function (checkElement) {
                if (value_checker_1.default.isBlank(checkElement.contractEndDate)) {
                    self_.setConfirmMessageAndDialog('申込内容オブジェクトを<strong>新規に追加</strong>します。よろしいですか？');
                    return {}; // 空のオブジェクトを返す
                }
                var cnvContractEndDate = dayjs_1.default(dayjs_1.default(checkElement.contractEndDate).format('YYYY-MM'));
                return self_.conmpareContractDateArray.map(function (contractElement) {
                    var cnvStartDate = dayjs_1.default(contractElement.startDate);
                    contractElement.isContinuity = cnvContractEndDate.add(1, 'month').isSame(cnvStartDate, 'month');
                    if (!contractElement.isContinuity) {
                        self_.confirmMessage = "<div class=\"col\">\u4EE5\u4E0B\u306E\u5546\u8AC7\u306B\u5BFE\u3057\u3066<strong>\u7533\u3057\u8FBC\u3093\u3060\u5229\u7528\u958B\u59CB\u6708\u304C\u9023\u7D9A\u3057\u3066\u3044\u307E\u305B\u3093\u3002</strong>\n                            <br>\u5FF5\u306E\u305F\u3081\u3001\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002<br>\n                            \u5BFE\u8C61\u306E\u5546\u8AC7: <a class='text-body-1' href='" + self_.$customEnv.get('SALES_FORCE_BASE_URL') + "lightning/r/Opportunity/" + checkElement.value.trim() + "/view' target='_blank'>" + checkElement.contractName + " \u5951\u7D04\u7D42\u4E86\u65E5\uFF1A" + checkElement.contractEndDate + "</a><br>\n                            \u5BFE\u8C61\u306E\u7533\u8FBC\u307F: <strong>" + contractElement.planName + " \u5229\u7528\u958B\u59CB\u6708\uFF1A" + contractElement.startDate + "</strong><br>\n                            \u305D\u308C\u3067\u3082\u3088\u308D\u3057\u3051\u308C\u3070\u3001\u4E0B\u8A18\u306E\u300COK\u300D\u30DC\u30BF\u30F3\u3092\u62BC\u3057\u3066\u304F\u3060\u3055\u3044\u3002</div>";
                        contractElement.confirmMessage = self_.confirmMessage;
                    }
                    return contractElement;
                });
            }).flat();
            self_.conmpareContractResultArray = self_.conmpareContractResultArray.filter(function (item) { return Object.keys(item).length !== 0; }); // 空のオブジェクトを除去
            self_.conmpareContractResultArray.forEach(function (result) {
                var hasFalse = self_.conmpareContractResultArray.some(function (element) { return element.isContinuity === false; });
                if (!result.isContinuity) {
                    self_.setConfirmMessageAndDialog(result.confirmMessage);
                }
                else if (!hasFalse) {
                    self_.setConfirmMessageAndDialog('申込内容オブジェクトを<strong>新規に追加</strong>します。よろしいですか？');
                }
            });
        }
        else if (self_.conmpareContractDateArray.length > 0) { // 既存の商談がない場合のメインプラン申込み
            self_.setConfirmMessageAndDialog('申込内容オブジェクトを<strong>新規に追加</strong>します。よろしいですか？');
        }
        else if (self_.inviteMailSentenceType.length > 0) { // アップグレード／モーションAI／タブレット単体申込みがある場合
            self_.setConfirmMessageAndDialog('申込内容オブジェクトを<strong>新規に追加</strong>します。よろしいですか？');
        }
    };
    ApplicationDetailsPre.prototype.submit = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var self_;
            return __generator(this, function (_a) {
                self_ = this;
                event.preventDefault();
                self_.getEarliestDateVariable(this.salesForceInfo.applyInfoEntryStartDate, this.salesForceInfo.applyInfoBasicStartDate, this.salesForceInfo.applyInfoOldStandardStartDate, this.salesForceInfo.applyInfoMediumStartDate, this.salesForceInfo.applyInfoStandardStartDate, this.salesForceInfo.applyInfoProfessionalStartDate, this.salesForceInfo.toUpgradeStartDate);
                if (value_checker_1.default.isBlank(self_.salesForceInfo.torihikisakiId)) {
                    this.alertMessage = String(this.$t('view.sales_force.reflect.msg.alert_torihikisaki_id'));
                    this.showAlertDialog = true;
                    return [2 /*return*/];
                }
                if (value_checker_1.default.isBlank(self_.salesForceInfo.applyTorihikisakiId)) {
                    this.alertMessage = String(this.$t('view.sales_force.reflect.msg.alert_torihikisaki_sekininsya_id'));
                    this.showAlertDialog = true;
                    return [2 /*return*/];
                }
                // 既存商談との連続性のチェック
                self_.checkContractStatusContinuityCheckRecord();
                // ekycをスキップするか判定
                self_.salesForceInfo = sales_force_input_utils_1.default.checkEkycSkip(self_.alreadyEkycLatestRecord, self_.salesForceInfo, self_.inviteMailSentenceType);
                // ekycが必要なプランと不要なプランの同時申込みかを判定
                self_.salesForceInfo = sales_force_input_utils_1.default.checkMixedEkycRequirement(self_.salesForceInfo, self_.inviteMailSentenceType);
                // tabletとメインプランの同時申込みか判定
                self_.salesForceInfo = sales_force_input_utils_1.default.isSequentialContractWithTabletAndMainPlan(self_.salesForceInfo, self_.inviteMailSentenceType);
                return [2 /*return*/];
            });
        });
    };
    ApplicationDetailsPre.prototype.dialogClose = function () {
        this.showConfirmDialog = false;
        this.showAlertDialog = false;
    };
    ApplicationDetailsPre.prototype.setConfirmMessageAndDialog = function (message) {
        this.confirmMessage = message;
        this.showConfirmDialog = true;
    };
    ApplicationDetailsPre.prototype.reflect = function () {
        var self_ = this;
        self_.dialogClose();
        this.$emit('reflect', this.getAjaxInfo());
    };
    ApplicationDetailsPre.prototype.getAjaxInfo = function () {
        if (!this.salesForceInfo.torihikisakiId) {
            this.salesForceInfo.torihikisakiId = '';
        }
        if (!this.salesForceInfo.applyTorihikisakiId) {
            this.salesForceInfo.applyTorihikisakiId = '';
        }
        if (!this.salesForceInfo.applicationDetailId) {
            this.salesForceInfo.applicationDetailId = '';
        }
        return {
            salesForceInfo: {
                torihikisakiId: this.salesForceInfo.torihikisakiId.trim(),
                applyTorihikisakiId: this.salesForceInfo.applyTorihikisakiId.trim(),
                applicationDetailId: this.salesForceInfo.applicationDetailId.trim(),
                emailSubjectPre: this.salesForceInfo.emailSubjectPre,
                emailContentPre: this.salesForceInfo.emailContentPre,
                scheduledApplicationContent: this.salesForceInfo.scheduledApplicationContent,
                emailAutoSendPre: this.salesForceInfo.emailAutoSendPre,
                entryPrimaryAssignedIdFlg: this.salesForceInfo.entryPrimaryAssignedIdFlg,
                basicPrimaryAssignedIdFlg: this.salesForceInfo.basicPrimaryAssignedIdFlg,
                oldStandardPrimaryAssignedIdFlg: this.salesForceInfo.oldStandardPrimaryAssignedIdFlg,
                mediumPrimaryAssignedIdFlg: this.salesForceInfo.mediumPrimaryAssignedIdFlg,
                standardPrimaryAssignedIdFlg: this.salesForceInfo.standardPrimaryAssignedIdFlg,
                professionalPrimaryAssignedIdFlg: this.salesForceInfo.professionalPrimaryAssignedIdFlg,
                upgradePrimaryAssignedIdFlg: this.salesForceInfo.upgradePrimaryAssignedIdFlg,
                corporateEkycSkipFlg: this.salesForceInfo.corporateEkycSkipFlg,
                personalEkycSkipFlg: this.salesForceInfo.personalEkycSkipFlg,
                isSequentialContractState: this.salesForceInfo.isSequentialContractState
            },
            reflectType: [ReflectType_1.SalesForceReflectType.APPLICATION_DETAILS_PRE],
            fetchTypes: [ReflectType_1.SalesForceReflectType.APPLICATION_DETAILS_PRE]
        };
    };
    __decorate([
        vue_property_decorator_1.Prop({ default: {} })
    ], ApplicationDetailsPre.prototype, "initData", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: {} })
    ], ApplicationDetailsPre.prototype, "initSalesForceData", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: {} })
    ], ApplicationDetailsPre.prototype, "contractStatusContinuityCheckRecord", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: {} })
    ], ApplicationDetailsPre.prototype, "alreadyEkycLatestRecord", void 0);
    __decorate([
        vue_property_decorator_1.Prop({
            default: function () {
            }
        })
    ], ApplicationDetailsPre.prototype, "fetchSalesForceInfo", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: '' })
    ], ApplicationDetailsPre.prototype, "documentId", void 0);
    __decorate([
        vue_property_decorator_1.Watch('initData')
    ], ApplicationDetailsPre.prototype, "initDataChange", null);
    __decorate([
        vue_property_decorator_1.Watch('initSalesForceData')
    ], ApplicationDetailsPre.prototype, "initSalesForceDataChange", null);
    ApplicationDetailsPre = __decorate([
        vue_property_decorator_1.Component({
            components: {
                SimpleDialog: SimpleDialog_1.default,
                MoveSalesForceButton: MoveSalesForceButton_1.default,
                SalesForceButtonArea: SalesForceButtonArea_1.default,
                DetailDataSingleLabel: DetailDataSingleLabel_1.default
            }
        })
    ], ApplicationDetailsPre);
    return ApplicationDetailsPre;
}(vue_property_decorator_1.Vue));
exports.default = ApplicationDetailsPre;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/sales_force/ApplicationDetailsPre.vue
// module id = XR05
// module chunks = 1